import { render, staticRenderFns } from "./SysMessageTestModal.vue?vue&type=template&id=617841f1&scoped=true"
import script from "./SysMessageTestModal.vue?vue&type=script&lang=js"
export * from "./SysMessageTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617841f1",
  null
  
)

export default component.exports